import React, { useState } from "react";
import { axiosNewInstance } from "../../config/Api";
import { toast } from "react-hot-toast";
import LangData from "../common/LangData";
import { useTranslation } from "react-i18next";

const RaiseRequest = () => {
    const { t } = useTranslation();
    const [grievance, setGrievance] = useState("");
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem("authToken");

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!grievance.trim()) {
            toast.error(t("placeholder_grievance"));
            return;
        }

        setLoading(true);
        try {
            const response = await axiosNewInstance.post(
                "/api-app/service-request",
                { grievance_text: grievance },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.status === "success") {
                toast.success(t("msg_grievance_submitted"));
                setGrievance("");
            } else {
                toast.error(response.data.message || t("msg_error"));
            }
        } catch (error) {
            console.error("Error submitting grievance:", error);
            toast.error(error.response?.data?.message || t("msg_error"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4">
            <div className="row justify-content-center">
                <div className="col-md-8 mx-auto">
                    <div className="card shadow-sm">
                        <div
                            className="card-header"
                            style={{ backgroundColor: "#004e8f", color: "white" }}
                        >
                            <h5 className="mb-0">
                                <LangData keyname="label_raise_request" />
                            </h5>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="form-group mb-4">
                                    <label htmlFor="grievance_text" className="form-label">
                                        <LangData keyname="placeholder_grievance" />
                                    </label>
                                    <textarea
                                        id="grievance_text"
                                        className="form-control"
                                        rows="6"
                                        maxLength="250"
                                        value={grievance}
                                        onChange={(e) => setGrievance(e.target.value)}
                                        placeholder={t("placeholder_grievance")}
                                        style={{ height: "auto", minHeight: "150px" }}
                                    ></textarea>
                                    <div className="text-right mt-2 text-muted">
                                        <small>{grievance.length}/250</small>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <button
                                        type="submit"
                                        className="btn btn-sm btn-primary"
                                        disabled={loading}
                                        style={{ height: "40px", backgroundColor: "#004e8f", padding: "0 25px", border: "none" }}
                                    >
                                        {loading ? (
                                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                        ) : null}
                                        <LangData keyname="label_submit" />
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <style dangerouslySetInnerHTML={{
                __html: `
                #grievance_text { height: auto !important; }
            `}} />
        </div>
    );
};

export default RaiseRequest;
